export default {
  "X-HW-APPKEY": "SUFXZm9LSyhDNF5ibzVEZw==", //uat
  "X-HW-ID": "com.huawei.mtl.supplier.sinobase", //uat
  exhibitionId: "2022ECOP",
  seminarId: 2201273068954623, //线下会id2201272431369989 2201273068954623
  onlineSeminarId: 2201272431369989,
  intoduceId: 2202230495039898, //大会介绍
  newsId: 2202093396101259, //热门资讯
  videosId: 2202091705043341, //精彩视频
  guestListId: 2201273068954623, //嘉宾列表
  bigViewId: 2204173834794556, //大咖观点
  advListId: 2206023805213559, //首页广告id
  tenantId: 519,
  schemaId: 3172,
  weChatId: 19200,
  memberFormId: 7241,
  agendaTypeDicId: 253996,
  agendaSeachID: 251066, //议程搜索字典id
  talkSeachID: 267559, //扫地僧索引字典id
  articleExhibitionId: 2203021930153655,
  partnerId: 2202090179561109,
  subPartnerId: 2205261871231769,
  mediaId: 2206073616783479, ////首页大会媒体id
  cityTravelDictId: 267680, //伙伴百城行 字典id
  cityTravelArticleId: 2206171769632319, //伙伴百城行 文章栏目id
  cityTravelSearchTypeId: 267700, //伙伴百城行 筛选类型字典id
  cityTravelSearchIndustryId: 267713, //伙伴百城行 筛选行业字典id
  cityTravelSearchpProductId: 267714, //伙伴百城行 筛选产品字典id
  articleRelation: {
    "华为张平安：深耕数字化，一切皆服务":
      "https://www.huaweicloud.com/news/2021/20210923084935881.html",
    昇腾行业AI赋能试验平台助力浙江移动推出数智赋能服务:
      "https://client.sina.cn/news/2022-05-20/detail-imcwiwst8459484.d.html",
  },
  agendaDateList: [
    {
      id: 0,
      day: "2022-06-15",
    },
    {
      id: 1,
      day: "2022-06-16",
    },
    {
      id: 2,
      day: "2022-06-17",
    },
  ], //日程日期列表 跳转议程二级页面用到 todo 上线前调整
  mapUrl:
    "https://www.amap.com/search?id=B02F37TV2J&city=440304&geoobj=114.171059%7C38.690953%7C120.323403%7C41.200437&query_type=IDQ&query=%E6%B7%B1%E5%9C%B3%E4%BC%9A%E5%B1%95%E4%B8%AD%E5%BF%83&zoom=8",
  guide: {
    notice: {
      content: 2203120096602281,
      after: {
        tips: 2203121650974743,
      },
      in: {
        tips: 2203123763415413,
      },
      before: {
        freeTesting: 2203123347321019,
        paymentTesting: 2203123097043779,
        subObj: 2203133886511553,
        tips: 2203132125665664,
      },
    },
  },
  cookie: {
    domain: document.domain === "localhost" ? "localhost" : ".huawei.com",
  },
  shareConfig: {
    title: "首届 “华为伙伴暨开发者大会” 来啦！",
    desc: "因聚而生 为你所能", // 描述信息
    imgUrl: `https://e-campaign.huawei.com/campaign/uat/partner-developer2022/images/shareIcon.png`, // 分享的小图标
  },
  homePage: "https://e-campaign.huawei.com/campaign/uat/partner-developer2022/",
  loginUrl: "https://app.events.huawei.com/uat/partner-developer2022/login",
  syUrl:
    "https://e-campaign.huawei.com/campaign/uat/partner-developer2022/cloud-form", //我要上云 url
  ticketedUrl: "https://sale.vmall.com/partner-developer2022.html", //购票链接
  signUpOnlineUrl:
    "https://app.events.huawei.com/uat/partner-developer2022/login",
  signUpOfflineUrl:
    "https://app.events.huawei.com/uat/partner-developer2022/offline/verifyCode",
  uniportalSignOut:
    "https://hwprojectuat-api.smarket.net.cn/hwid/loginOut?sess=", //以 uniportal 登录 方式 退出的
  signOnlineUrl:
    "https://app.events.huawei.com/uat/partner-developer2022/online/sign",
  verificationCodeUrl: "/vmall/simpleSignUp", //核验票码 接口
  getQrcode:
    "https://hwprojectuat-api.smarket.net.cn/vmall/seminar/contacts/getqrcode", //获取门票二维码
  partnerUrl:
    "https://e-campaign.huawei.com/campaign/partner2021-minisite-1/home", //华为生态
  HDCUrl: "https://developer.huaweicloud.com/HDC.Cloud2021.html", //HDC
  svgMapUrl:
    "https://e-campaign.huawei.com/campaign/test/partner-developer2022/", //svg地图 路径
  // svgMapUrl: window.location.protocol + "//" + window.location.host + "/", //svg地图 路径
  signUpOfflineUrl_new:
    "https://app.events.huawei.com/uat/partner-developer2022/offline/sign",
  vhallUrl: "https://live.huawei.com/HPDC/meeting/cn/",
  introduceVideo:
    "https://1500010779.vod2.myqcloud.com/6ca9a800vodcq1500010779/381f2807387702301864511550/vVqMURoEY8kA.mp4",
  morningMainSeminarId: 2206023831519269,
  afternoonMainSeminarId: 2206020304305859,
  api: {
    gateway: {
      general: "https://hwyuat-api.smarket.net.cn",
      project: "https://hwprojectuat-api.smarket.net.cn",
      JsonUrl: "https://hwuat-static.smarket.net.cn",
      hwUrl: "https://apigw-beta.huawei.com",
    },
    ungateway: {
      contentUrl: "https://uat-content.smarket.net.cn/index.php",
    },
  },
  weChatOauthUrl:
    "https://uat-wxoauthb.smarket.net.cn/public/wx_interface/auth",
  warningLog: {
    accessToken: "",
    title: "测试页面报警",
    ignoreList: {
      "/member/login": "401", // 第三方用户登录 未绑定
      "/article/getCollectionList": "268451864", // 文章收藏列表为空
    },
  },
  isStatic: true,
  isSK: true,
  activityId: 35, //互动活动id
  interactionUrl:
    "https://app.events.huawei.com/uat/partner-developer2022-interaction",
};
